import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginStorage } from '../../login/login.storage';
import { LoaderService } from '../../shared/loader/loader.service';
import { OmniRestService } from '../omni-rest.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class OmniMaisV2RestService extends OmniRestService {
  public auth: { login: string; token: string };

  constructor(http: HttpClient, loaderService: LoaderService, loginStorage: LoginStorage, router: Router) {
    super(http, loaderService, loginStorage, router);
  }

  getBaseUrl(): string {
    return environment.URL_OMNI_MAIS_API_V2;
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'omni-autenticacao': this.auth
        ? JSON.stringify(this.auth)
        : this.loginStorage.loginAndTokenAsJson,
    };
  }
}
